import styled from "styled-components";
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { MdHomeFilled } from "react-icons/md";

const TopBar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 0.9rem 2rem;
  background: rgba(15, 12, 41, 0.6);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  z-index: 1000;
  transition: background 0.3s ease;

  @media (max-width: 600px) {
    padding: 0.7rem 0.8rem;
  }
`;

const TopLink = styled(Link)`
  color: rgba(255, 255, 255, 0.65);
  margin-left: 1.8rem;
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 500;
  letter-spacing: 0.01em;
  white-space: nowrap;
  transition: color 0.2s ease;

  &:hover {
    color: white;
  }

  @media (max-width: 600px) {
    margin-left: 0.8rem;
    font-size: 0.8rem;
  }

  & img {
    width: 22px;
    height: 20px;
    padding-left: 3px;
    margin-top: 3px;
    opacity: 0.65;
    transition: opacity 0.2s;
  }

  &:hover img {
    opacity: 1;
  }
`;

const LineButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-left: 1.8rem;
  padding: 0.45rem 1.2rem;
  border-radius: 8px;
  white-space: nowrap;
  background: rgba(6, 199, 85, 0.2);

  @media (max-width: 600px) {
    margin-left: 0.8rem;
    padding: 0.4rem 0.7rem;
    font-size: 0.8rem;
  }
  border: 1px solid rgba(6, 199, 85, 0.35);
  color: #6ee7a0;
  font-size: 0.85rem;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(6, 199, 85, 0.35);
    border-color: rgba(6, 199, 85, 0.55);
    color: white;
  }

  & img {
    width: 20px;
    height: 20px;
    opacity: 0.9;
    transition: opacity 0.2s;
  }

  &:hover img {
    opacity: 1;
  }
`;

const HomeButton = styled(Link)`
  display: flex;
  align-items: center;
  color: rgba(255, 255, 255, 0.75);
  margin-right: auto;
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: white;
  }
`;

const SignInButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  margin-left: 1.8rem;
  padding: 0.45rem 1.2rem;
  border-radius: 8px;
  background: rgba(99, 102, 241, 0.25);

  @media (max-width: 600px) {
    margin-left: 0.8rem;
    padding: 0.4rem 0.7rem;
    font-size: 0.8rem;
  }
  border: 1px solid rgba(99, 102, 241, 0.35);
  color: #c7d2fe;
  font-size: 0.85rem;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(99, 102, 241, 0.4);
    border-color: rgba(99, 102, 241, 0.55);
    color: white;
  }
`;

const TopBarNav = ({ onSignInClick }) => {
  const { t } = useTranslation();

  return (
    <TopBar>
      <HomeButton to="/">
        <MdHomeFilled size={22} />
      </HomeButton>
      <TopLink to="/about-us">{t('TopBarAboutUs')}</TopLink>
      <TopLink to="/privacy">{t('Privacy')}</TopLink>
      <LineButton to="/line">
        <img src="/line-icon.png" alt="LINE" />
        LINE
      </LineButton>
      <SignInButton to="#" onClick={(e) => { e.preventDefault(); if (onSignInClick) onSignInClick(); }}>
        {t('AccountSignUp')}
      </SignInButton>
    </TopBar>
  );
};

export default TopBarNav;
